import React, { useState, useContext } from "react";
import axios from "../../axiosConfig";
import { TrainerContext } from "../../context/TrainerContext";
import { useToast } from "../commons/toast/ToastContext";
import "../../styles/ExerciseModal.css";
import { AiOutlineClose } from "react-icons/ai";

const AddExerciseModal = ({ onClose, onSuccess }) => {
    const { trainer } = useContext(TrainerContext);
    const toast = useToast();
    const [formData, setFormData] = useState({
        name: "",
        description: "",
        requiredEquipment: "",
        difficultyLevel: "BASIC",
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post(`/api/v1/exercise/school/${trainer.schoolId}/add`, formData, {
                headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` },
            });

            toast.success(`Ćwiczenie "${formData.name}" zostało dodane.`, "Sukces");

            if (onSuccess) {
                onSuccess(response.data);
            }
            onClose();
        } catch (err) {
            toast.error("Nie udało się dodać ćwiczenia. Spróbuj ponownie.", "Błąd");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>Dodaj ćwiczenie</h2>
                    <AiOutlineClose className="close-icon" onClick={onClose} />
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder="nazwa..."
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="text"
                            name="requiredEquipment"
                            value={formData.requiredEquipment}
                            onChange={handleChange}
                            placeholder="wyposażenie"
                        />
                    </div>
                    <div className="form-group">
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            required
                            placeholder="opis..."
                            className="large-textarea"
                        />
                    </div>
                    <div className="form-group">
                        <select
                            name="difficultyLevel"
                            value={formData.difficultyLevel}
                            onChange={handleChange}
                        >
                            <option value="BASIC">Podstawowy</option>
                            <option value="INTERMEDIATE">Średniozaawansowany</option>
                            <option value="ADVANCED">Zaawansowany</option>
                        </select>
                    </div>
                    <div className="modal-buttons">
                        <button type="button" className="cancel-btn" onClick={onClose}>
                            Anuluj
                        </button>
                        <button
                            type="submit"
                            className={`save-btn ${loading ? "disabled" : ""}`}
                            disabled={loading}
                        >
                            {loading ? "Zapisywanie..." : "Zapisz"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddExerciseModal;